// @module SuiteDB.SDBFooterLinks.SDBFooterLinks
define("SuiteDB.SDBFooterLinks.SDBFooterLinks.View", [
  "suitedb_sdbfooterlinks_sdbfooterlinks.tpl",

  "SuiteDB.SDBFooterLinks.SDBFooterLinks.SS2Model",

  "Backbone",
], function (
  suitedb_sdbfooterlinks_sdbfooterlinks_tpl,

  SDBFooterLinksSS2Model,

  Backbone
) {
  "use strict";

  // @class SuiteDB.SDBFooterLinks.SDBFooterLinks.View @extends Backbone.View
  return Backbone.View.extend({
    template: suitedb_sdbfooterlinks_sdbfooterlinks_tpl,

    initialize: function initialize(options) {
      /*  Uncomment to test backend communication with an example service
      	(you'll need to deploy and activate the extension first)
      */
      // this.model = new SDBFooterLinksModel();
      // var self = this;
      // this.model.fetch().done(function(result) {
      // 	self.message = result.message;
      // 	self.render();
      // });
    },
    events: {},
    bindings: {},
    childViews: {},

    //@method getContext @return SuiteDB.SDBFooterLinks.SDBFooterLinks.View.Context
    getContext: function getContext() {
      //@class SuiteDB.SDBFooterLinks.SDBFooterLinks.View.Context
      /* this.message = this.message || 'Hello World!!'
      return {
      	message: this.message
      }; */
    },
  });
});
